module.exports = __webpack_public_path__ + "img/Pink.1dc4001c.png";